module.exports = __webpack_public_path__ + "static/media/20-3.fbbe68f5.mp3";